import React from "react";
import { useAppSelector } from "@lib/stores";
import { SVG } from "@components/items/common/SVG";
import { useGoogleLogin } from "@react-oauth/google";
import { useLinkedAccounts } from "../hooks/useLinkedAccounts";
import AppleLogin from "react-apple-login";
import TranslatedText from "@components/items/display/TranslatedText";
import { ResourcesKey } from "@modules/localizations/translate";

const LinkedAccounts = () => {
  const AUTH_PROVIDERS = ["google", "apple"];
  const linkedAccounts = useAppSelector((state) => state.auth.linkedProviders);

  const { onGoogleSubmit, onAppleSubmit, isApplePopup } = useLinkedAccounts();

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      onGoogleSubmit(codeResponse);
    },
  });

  const isConnected = (name: string) => {
    return linkedAccounts.data?.data?.find(
      (li) => li.providerName?.toLowerCase() === name
    );
  };
  return (
    <div className="grid w-full grid-cols-3 items-center justify-start py-5">
      <TranslatedText
        text="settings.titles.linked accounts"
        className="text-black dark:text-white"
      />
      <div className="flex h-full w-full flex-col items-center justify-around text-[15px]">
        {AUTH_PROVIDERS.map((provider) => (
          <TranslatedText
            key={provider}
            text={`settings.titles.${provider}` as ResourcesKey}
            className="w-full text-black ltr:text-left rtl:text-right dark:text-white"
          />
        ))}
      </div>
      <div className="flex flex-col items-end justify-center gap-3">
        <div
          className={`flex w-[120px] items-center justify-between gap-2 rounded-lg bg-[#D9D9D9] px-4 py-3 ${
            !isConnected("google") && "cursor-pointer"
          }`}
          onClick={() => {
            !isConnected("google") && googleLogin();
          }}
        >
          <TranslatedText
            text={`settings.titles.${
              isConnected("google") ? "connected" : "connect"
            }`}
            className={`text-[12px] font-medium !text-primary`}
          />
          <SVG src={`/assets/icons/google.svg`} className="h-5 w-5" />
        </div>
        <AppleLogin
          clientId="7ULS9RAK3M.octadevtn.wamdha"
          redirectURI={window.location.origin}
          responseMode="query"
          usePopup={isApplePopup}
          render={(renderProps) => (
            <div
              className={`flex w-[120px] items-center justify-between gap-2 rounded-lg bg-black px-4 py-3 ${
                !isConnected("apple") && "cursor-pointer"
              }`}
              onClick={renderProps.onClick}
            >
              <TranslatedText
                text={`settings.titles.${
                  isConnected("apple") ? "connected" : "connect"
                }`}
                className={`text-[12px] font-medium text-white`}
              />
              <SVG src={`/assets/icons/apple-icon.svg`} className="h-5 w-5" />
            </div>
          )}
          callback={onAppleSubmit}
        />
      </div>
    </div>
  );
};

export default LinkedAccounts;
